module.exports = __webpack_public_path__ + "img/light_6.df6982c2.png";